export const Colors = {
  blue: '#253746',
  red: '#bd472a',
  light: 'hsla(0,0%,100%,.5)'
};
